module.exports = __webpack_public_path__ + "img/DE05921.51fdfb7e.png";